<template>
    <div>
        <div id="teste" class="azfloat" style="position: relative;">
            <button v-if="!iconOnly" class="btn btn-link m-0 p-0" type="button" @click="action ? action () : ''" ref="ancora">
                <i :class="icon ? icon : 'fas fa-user-injured'" class="text-primary"
                    @mouseover="exibir ()" @mouseleave="showPanel = false"></i>
            </button>
            
            <i v-else :class="icon ? icon : 'fas fa-user-injured'" @click="action ? action () : ''" ref="ancora" class="text-primary"
                    @mouseover="exibir ()" @mouseleave="showPanel = false"></i>

            <div class="card painel" v-if="showPanel" :class="pos_class" ref="painel" id="painel" :style="custom_width ? 'width: ' + custom_width : ''">
                <div class="card-header" :class="'bg-' + headerColor()" v-if="title">
                    {{ title }}
                </div>
                <div class="card-body text-wrap" :class="'alert-' + bodyColor()">
                    <template v-if="block">
                        ... 
                    </template>
                    <template v-else>
                        <slot></slot>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () { 
        return { 
            showPanel: false,
            pos_class: "ajuste-left"
        }
    },
    props: ['title', 'icon', 'classe', 'action', 'sync', 'color', 'block', 'custom_width', 'iconOnly'],

    methods: { 
        headerColor () { 
            return ( this.color ? this.color : 'success' ) + ( this.color == 'light' ? '' : ' text-white');
        },

        bodyColor () { 
            return this.color ? this.color : 'success';
        },

        exibir () { 

            if ( this.block )
                return;

            let posic = function elementInViewport(el) {
                
                var top = el.offsetTop;
                var left = el.offsetLeft;
                var width = el.offsetWidth;
                var height = el.offsetHeight;

                while(el.offsetParent) {
                    el = el.offsetParent;
                    top += el.offsetTop ? el.offsetTop : 0;
                    left += el.offsetLeft ? el.offsetLeft : 0;
                }

                return { top: top, left: left, width: width, height: height };

            }

            this.pos_class = "";
            let tp = posic(this.$refs.ancora);

            if ( window.innerWidth - tp.left > 350 ) { 
                this.pos_class = this.pos_class + "ajuste-left";
            } else { 
                this.pos_class = this.pos_class + "ajuste-right";
            }

            this.showPanel = true;

            this.$forceUpdate ();

            if ( this.sync )
                this.sync ();
        }
    }
}
</script>

<style scoped>
.painel { 
  position: absolute;
  overflow: auto;
  overflow-wrap: break-word;
  word-break: break-all;
  line-break: anywhere;
  width: 300px;
  z-index: 1010;  
  padding: 0px;
  top: -30px;
  visibility: hidden;
}

/* Show the tooltip text when you mouse over the tooltip container */
.azfloat:hover .painel {
  visibility: visible;
}

.ajuste-left { 
    left: 30px !important;
}

.ajuste-right { 
    left: -315px !important;    
}

.ajuste-top { 
    bottom: 100%;
    left: 50%;
    margin-left: -150px;
}

.ajuste-bottom { 
    left: -150px !important;    
    top: 30px !important;    
}

.right { 
  right: 100%;
  top: -30px;   
}

.left { 
  left: 100%;
  top: -30px;
}

.azfloat .painel {
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

.azfloat:hover .painel {
  opacity: 1;
}

.painel::after {
  content: "XXX";
  position: absolute;
  top: 50%;
  right: 100%; /* To the left of the tooltip */
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent black transparent transparent;
}

</style>